import {commentAxios} from "../commentAxios";

export const getCommentList = (entityId, type, order) => {
    return commentAxios.get('/comments/list', {
        params: {
            entityId: entityId,
            type: type,
            order: order
        }
    })
        .catch(() => {
            console.log('failed')
        });
};
